import { unit, sumUnits, massVolumeDensityTriad } from '@othrworld/units';
const getSpacecraftPartDryMass = (part) => {
    switch (part.type) {
        case 'engine':
            return part.mass;
        case 'fuel-container':
            return part.dryMass;
        case 'battery':
            return part.mass;
    }
};
const getSpacecraftPartFuelMass = (part) => {
    switch (part.type) {
        case 'fuel-container':
            return massVolumeDensityTriad.getUp(part.fuelVolume, part.fuelDensity);
        default:
            return unit(0);
    }
};
export const getSpacecraftDryMass = (s) => sumUnits(s.dryMass, ...s.parts.map(getSpacecraftPartDryMass));
export const getSpacecraftFuelMass = (s) => sumUnits(...s.parts.map(getSpacecraftPartFuelMass));
export const getSpacecraftMass = (s) => sumUnits(getSpacecraftDryMass(s), getSpacecraftFuelMass(s));
//# sourceMappingURL=mass.js.map